<template>
  <v-row class="mb-8">
    <v-col cols="12" class="mt-4">
      <h3 v-if="!loading" class="font-weight-regular text-uppercase">Speakers:</h3>
    </v-col>

    <v-col 
      cols="12" 
      xl="3" 
      md="3" 
      sm="12" 
      align="center"
      v-for="(speaker) in speakers" 
      :key="speaker.id">

      <cardPerson 
        v-if="!loading" 
        :data="speaker" 
        :backgroundCard="speaker_background_card" 
      />
      
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL
  import { mapGetters } from 'vuex'
  import cardPerson from '@/components/card/cardPerson'

  export default {
    name: 'speakersEdition',
    components:{cardPerson},

    data: () => ({
      loading:true,
      speakers:[],
      speaker_background_card: null,
      edition_id: null
    }),
    computed: {
      ...mapGetters([
        'edition'
      ])
    },
    methods:{
      setData(){
        this.speaker_background_card = APP_URL + this.edition.edition.edition_customization.speaker_background_card
      },

      async getSpeakersEdition(){
        await axios.get('participant/speakers/'+this.edition.edition.id).then(response =>{
          this.speakers = response.data.data.speakers
        }).catch(error => {
          console.log(error);
        })
      },

      handleEdition(){
        if(this.edition.edition.waiting_room){
          this.loading = false
          this.$router.push({ name: 'home' })
        }
      }
    },
    created(){
      Promise.all([
        this.handleEdition(),
        this.setData(),
        this.getSpeakersEdition()
      ]).then(() => {
        this.loading=false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
